import { render, staticRenderFns } from "./MultipleSelect.vue?vue&type=template&id=1b0ff807&"
import script from "./MultipleSelect.vue?vue&type=script&lang=ts&"
export * from "./MultipleSelect.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports